// extracted by mini-css-extract-plugin
export default {"nav-tab":"MultiTab_nav-tab__+LNcN","main-content":"MultiTab_main-content__rWhVK","left":"MultiTab_left__Ry4zD","right":"MultiTab_right__XFDeu","selected":"MultiTab_selected__YYlyW"};